"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _apolloClient = require("@/apollo/apolloClient");
var _recruitmentQuery = require("@/apollo/queries/recruitment-query");
var state = {
  // ページング（ページトップNo）
  page_top: 0,
  // ページング（１ページあたりの表示サイズ）
  page_size: 50,
  // ページング（全一覧数）
  page_count: 0,
  // ページング（最終ページ）
  page_last: 0,
  recruitment: {},
  recruitments: [],
  messages: [],
  searchRecruitmentText: '',
  searchActive: ''
};
var mutations = {
  UPDATE_RECRUITMENT: function UPDATE_RECRUITMENT(state, recruitment_info) {
    state.recruitment = recruitment_info.map(function (recruitment_info) {
      return recruitment_info;
    });
  },
  UPDATE_RECRUITMENTS: function UPDATE_RECRUITMENTS(state, recruitments) {
    state.recruitments = recruitments.map(function (recruitment_info) {
      return recruitment_info;
    });
  },
  UPDATE_RECRUITMENT_MESSAGES: function UPDATE_RECRUITMENT_MESSAGES(state, messages) {
    state.messages = messages.map(function (recruitment_message) {
      return recruitment_message;
    });
  },
  SET_SEARCH_ACTIVE: function SET_SEARCH_ACTIVE(state, val) {
    state.searchActive = val;
  },
  SET_RECRUITMENT_TEXT: function SET_RECRUITMENT_TEXT(state, val) {
    state.searchRecruitmentText = val;
  },
  setPageTop: function setPageTop(state, val) {
    state.page_top = val;
  },
  setPageSize: function setPageSize(state, val) {
    state.page_size = val;
  },
  setPageCount: function setPageCount(state, val) {
    state.page_count = val;
  }
};
var actions = {
  setPageTop: function () {
    var _setPageTop = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref, page_top) {
      var commit;
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            commit('setPageTop', page_top);
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function setPageTop(_x, _x2) {
      return _setPageTop.apply(this, arguments);
    }
    return setPageTop;
  }(),
  getPageTop: function () {
    var _getPageTop = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref2) {
      var commit;
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref2.commit;
            return _context2.abrupt("return", state.page_top);
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function getPageTop(_x3) {
      return _getPageTop.apply(this, arguments);
    }
    return getPageTop;
  }(),
  getPageLast: function () {
    var _getPageLast = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref3) {
      var commit;
      return regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            commit = _ref3.commit;
            return _context3.abrupt("return", state.page_last);
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    function getPageLast(_x4) {
      return _getPageLast.apply(this, arguments);
    }
    return getPageLast;
  }(),
  setPageSize: function () {
    var _setPageSize = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref4, page_size) {
      var commit;
      return regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            commit = _ref4.commit;
            commit('setPageSize', page_size);
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    function setPageSize(_x5, _x6) {
      return _setPageSize.apply(this, arguments);
    }
    return setPageSize;
  }(),
  setPageCount: function () {
    var _setPageCount = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref5, page_count) {
      var commit;
      return regeneratorRuntime.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            commit = _ref5.commit;
            commit('setPageCount', page_count);
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    function setPageCount(_x7, _x8) {
      return _setPageCount.apply(this, arguments);
    }
    return setPageCount;
  }(),
  getPageCount: function () {
    var _getPageCount = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref6) {
      var commit;
      return regeneratorRuntime.wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            commit = _ref6.commit;
            return _context6.abrupt("return", state.page_count);
          case 1:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    function getPageCount(_x9) {
      return _getPageCount.apply(this, arguments);
    }
    return getPageCount;
  }(),
  fetchRecruitment: function () {
    var _fetchRecruitment = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(_ref7, uid) {
      var commit, res;
      return regeneratorRuntime.wrap(function (_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            commit = _ref7.commit;
            _context7.next = 1;
            return _apolloClient.apolloClient.query({
              query: _recruitmentQuery.RECRUITMENT_QUERY,
              variables: {
                client_uuid: uid
              }
            });
          case 1:
            res = _context7.sent;
            commit('UPDATE_RECRUITMENT', res.data.recruitment_info);
          case 2:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    function fetchRecruitment(_x0, _x1) {
      return _fetchRecruitment.apply(this, arguments);
    }
    return fetchRecruitment;
  }(),
  fetchRecruitmentID: function () {
    var _fetchRecruitmentID = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee8(_ref8, id) {
      var commit, res;
      return regeneratorRuntime.wrap(function (_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            commit = _ref8.commit;
            _context8.next = 1;
            return _apolloClient.apolloClient.query({
              query: _recruitmentQuery.GET_RECRUITMENT,
              variables: {
                id: id
              }
            });
          case 1:
            res = _context8.sent;
            commit('UPDATE_RECRUITMENT', res.data.recruitment_info);
          case 2:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    function fetchRecruitmentID(_x10, _x11) {
      return _fetchRecruitmentID.apply(this, arguments);
    }
    return fetchRecruitmentID;
  }(),
  fetchRecruitments: function () {
    var _fetchRecruitments = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee9(_ref9, id) {
      var commit, _sWord, _bActive, cnt, res;
      return regeneratorRuntime.wrap(function (_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            commit = _ref9.commit;
            if (state.searchRecruitmentText) {
              _sWord = "%".concat(state.searchRecruitmentText, "%");
            } else {
              _sWord = '%';
            }
            if (state.searchActive === true || state.searchActive === false) {
              _bActive = state.searchActive;
            } else {
              _bActive = null;
            }
            _context9.next = 1;
            return _apolloClient.apolloClient.query({
              query: _recruitmentQuery.RECRUITMENTS_LIST_COUNT,
              variables: {
                uuid: id,
                search_word: _sWord,
                is_active: _bActive
              }
            });
          case 1:
            cnt = _context9.sent;
            state.page_size = 50;
            state.page_count = cnt.data.recruitment_info_aggregate.aggregate.count;
            state.page_last = cnt.data.recruitment_info_aggregate.aggregate.count === 0 ? 0 : Math.ceil(cnt.data.recruitment_info_aggregate.aggregate.count / state.page_size) - 1;
            _context9.next = 2;
            return _apolloClient.apolloClient.query({
              query: _recruitmentQuery.RECRUITMENTS_LIST_QUERY,
              variables: {
                uuid: id,
                search_word: _sWord,
                is_active: _bActive,
                page_top: state.page_top * state.page_size,
                page_size: state.page_size
              }
            });
          case 2:
            res = _context9.sent;
            commit('UPDATE_RECRUITMENTS', res.data.recruitment_info);
          case 3:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    function fetchRecruitments(_x12, _x13) {
      return _fetchRecruitments.apply(this, arguments);
    }
    return fetchRecruitments;
  }(),
  fetchRecruitmentMessages: function () {
    var _fetchRecruitmentMessages = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee0(_ref0, id) {
      var commit, res;
      return regeneratorRuntime.wrap(function (_context0) {
        while (1) switch (_context0.prev = _context0.next) {
          case 0:
            commit = _ref0.commit;
            _context0.next = 1;
            return _apolloClient.apolloClient.query({
              query: _recruitmentQuery.RECRUITMENT_MESSAGES,
              variables: {
                id: id
              }
            });
          case 1:
            res = _context0.sent;
            commit('UPDATE_RECRUITMENT_MESSAGES', res.data.recruitment_message);
          case 2:
          case "end":
            return _context0.stop();
        }
      }, _callee0);
    }));
    function fetchRecruitmentMessages(_x14, _x15) {
      return _fetchRecruitmentMessages.apply(this, arguments);
    }
    return fetchRecruitmentMessages;
  }(),
  setSearchActive: function () {
    var _setSearchActive = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee1(_ref1, val) {
      var commit;
      return regeneratorRuntime.wrap(function (_context1) {
        while (1) switch (_context1.prev = _context1.next) {
          case 0:
            commit = _ref1.commit;
            commit('SET_SEARCH_ACTIVE', val);
          case 1:
          case "end":
            return _context1.stop();
        }
      }, _callee1);
    }));
    function setSearchActive(_x16, _x17) {
      return _setSearchActive.apply(this, arguments);
    }
    return setSearchActive;
  }(),
  setRecruitmentText: function () {
    var _setRecruitmentText = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee10(_ref10, val) {
      var commit;
      return regeneratorRuntime.wrap(function (_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            commit = _ref10.commit;
            commit('SET_RECRUITMENT_TEXT', val);
          case 1:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
    function setRecruitmentText(_x18, _x19) {
      return _setRecruitmentText.apply(this, arguments);
    }
    return setRecruitmentText;
  }()
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};